import React, { useEffect, useState } from "react";
import ModalWrapper from "../../../app/common/modals/ModalWrapper";
import Carousel from "react-bootstrap/Carousel";
import {
  NavigationArrowLeft,
  NavigationArrowRight,
} from "../../../assets/icons";
import { Button, Grid, List } from "semantic-ui-react";
import { useDispatch } from "react-redux";
import mapMarkerIcon from "../../../assets/icons/map-marker-empty.svg";
import listIcon from "../../../assets/icons/list-icon.svg";
import plusIcon from "../../../assets/icons/plus.svg";
import menuIcon from "../../../assets/icons/menu.svg";
import previewIcon from "../../../assets/icons/preview-hover-icon.svg";
import editIcon from "../../../assets/icons/edit-pencil-hover-icon.svg";
import statsIcon from "../../../assets/icons/stats-icon-hover.svg";
import toggleOn from "../../../assets/icons/toggle-on-icon.svg";
import repostIcon from "../../../assets/icons/repost-hover-icon.svg";
import avatar from "../../../assets/icons/seethru-avatar.svg";
import { TEAL_BOX } from "../../../css/styles";
import { useHistory } from "react-router-dom";
import { closeModal } from "../../../app/common/modals/modalReducer";
import {
  EMPLOYER_COMPANY_PROFILE_PATH,
  EMPLOYER_DASHBOARD_MANAGE_JOBS_PATH,
  EMPLOYER_DASHBOARD_POST_JOB_PATH,
  EMPLOYER_PROMOTION_SERVICES_PATH,
  FAQ_ROUTE,
} from "../../../app/api/routeConstants";
import HorizontalProgressBar from "../../../app/common/components/HorizontalProgressBar";
import TextLink from "../../../app/common/components/TextLink";
import arrowRight from "../../../assets/icons/arrow-right-blue.svg";
import { COUPONS_AND_REWARDS } from "../employerConstanst";

const WELCOME_STEP = 0;
const OUR_DIFFERENCE_STEP = 1;
const POST_JOB_STEP = 4;
const MANAGE_JOBS_STEP = 5;

export default function GettingStartedEmployerModal({
  step = WELCOME_STEP,
  isTransitionEnd = false,
}) {
  const dispatch = useDispatch();
  const history = useHistory();

  const [index, setIndex] = useState(step);

  const [isCarouselTransitionEnd, setIsCarouselTransitionEnd] =
    useState(isTransitionEnd);
  const [isShowProgressBar, setIsShowProgressBar] = useState(false);

  useEffect(() => {
    if (index !== WELCOME_STEP && isCarouselTransitionEnd) {
      setIsShowProgressBar(true);
    } else if (index === WELCOME_STEP) {
      setIsShowProgressBar(false);
    }
  }, [index, isCarouselTransitionEnd, setIsShowProgressBar]);

  function handleNavigateRight() {
    setIsCarouselTransitionEnd(false);
    setIndex(index + 1);
  }

  function handleNavigateLeft() {
    setIsCarouselTransitionEnd(false);
    setIndex(index - 1);
  }

  const navigateRight = (
    <span onClick={handleNavigateRight}>
      <NavigationArrowRight />
    </span>
  );

  const navigateLeft = (
    <span onClick={handleNavigateLeft}>
      <NavigationArrowLeft />
    </span>
  );

  return (
    <ModalWrapper
      modalClassName="modal-ux-wrapper"
      style={{ width: "1000px", height: 655 }}
      showDuration={450}
      hideDuration={200}
    >
      <Carousel
        interval={null}
        keyboard={true}
        controls={false}
        touch={false}
        indicators={false}
        activeIndex={index}
        onSlid={() => {
          setIsCarouselTransitionEnd(true);
        }}
        className={"body-modal-text"}
      >
        <Carousel.Item>
          <div className="display-flex" style={{ height: 655 }}>
            <div className="getting-started-strapline-container">
              <div className="strapline-text white-text">
                <span>hello new job, </span>
                <span className="home-hero-secondary-text-underline">
                  hello new hire
                </span>
                <span className="accent-colour home-hero-secondary-text-underline">
                  .
                </span>
              </div>
            </div>
            <div style={{ padding: "65px 20px 65px 40px", width: "45%" }}>
              <h1 style={{ fontWeight: 500 }}>Getting started</h1>
              <h3 style={{ margin: "25px 0 35px" }}>
                Whether you are new to hiring, or an expert, we want you to get
                the most out of our platform. This guide will help you get
                started!
              </h3>
              <div style={{ ...TEAL_BOX, padding: "10px 20px" }}>
                <div className="guide-section-links">
                  <div
                    className="content-action-text"
                    style={{ marginBottom: 10 }}
                    onClick={() => {
                      setIsCarouselTransitionEnd(false);
                      setIndex(OUR_DIFFERENCE_STEP);
                    }}
                  >
                    About Hello Radius
                    <span className="float-right">
                      <img
                        src={arrowRight}
                        style={{ width: 17, height: 14 }}
                        alt="arrow right"
                      />
                    </span>
                  </div>
                  <div
                    className="content-action-text"
                    style={{ marginBottom: 10 }}
                    onClick={() => {
                      setIsCarouselTransitionEnd(false);
                      setIndex(POST_JOB_STEP);
                    }}
                  >
                    Post a Job
                    <span className="float-right">
                      <img
                        src={arrowRight}
                        style={{ width: 17, height: 14 }}
                        alt="arrow right"
                      />
                    </span>
                  </div>
                  <div
                    className="content-action-text"
                    style={{ marginBottom: 10 }}
                    onClick={() => {
                      setIsCarouselTransitionEnd(false);
                      setIndex(MANAGE_JOBS_STEP);
                    }}
                  >
                    Managing Your Jobs
                    <span className="float-right">
                      <img
                        src={arrowRight}
                        style={{ width: 17, height: 14 }}
                        alt="arrow right"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ width: "5%" }} className="center-flex">
              {navigateRight}
            </div>
          </div>
        </Carousel.Item>
        <Carousel.Item>
          <Grid style={{ height: "615px", margin: 0 }}>
            <Grid.Column width={1} verticalAlign="middle" textAlign="center">
              {isCarouselTransitionEnd && navigateLeft}
            </Grid.Column>
            <Grid.Column width={14} style={{ padding: "24px 0 14px 0" }}>
              <Grid.Row>
                <h3>About Hello Radius</h3>
              </Grid.Row>
              <Grid.Row>
                <div style={{ marginTop: 16, paddingRight: "18%" }}>
                  When you post a job with us, it will be clearly visible on our
                  interactive map and shown in three types of displays; List
                  Display, Quick-view Display and Full-page Display. At no extra
                  cost to you.
                </div>
              </Grid.Row>
              <Grid.Row style={{ marginTop: 15 }}>
                <h3 style={{ marginTop: 10 }}>
                  <img
                    src={mapMarkerIcon}
                    alt="map marker"
                    style={{ marginRight: 6 }}
                  />{" "}
                  Interactive Map
                </h3>
                <div style={{ paddingRight: "18%" }}>
                  By using our map, Job Seekers can see your opportunities
                  quicker and find a job more easily near their ideal work
                  location.
                </div>
              </Grid.Row>
              <Grid.Row>
                <img
                  src={
                    "https://firebasestorage.googleapis.com/v0/b/helloradius-caf9d.appspot.com/o/photos%2FGSG-map-page.jpg?alt=media&token=f387637e-be33-4ff5-b03e-2d6b0de560b4"
                  }
                  alt={"map"}
                  style={{
                    marginTop: 16,
                    height: "345px",
                    border: "1px solid #c2c5c7",
                    borderRadius: 8,
                  }}
                />
                <div style={{ fontSize: 12 }}>
                  The jobs and map markers shown are for illustrative purposes
                  only and do not represent real jobs.
                </div>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column width={1} verticalAlign="middle" textAlign="center">
              {isCarouselTransitionEnd && navigateRight}
            </Grid.Column>
          </Grid>
        </Carousel.Item>
        <Carousel.Item>
          <Grid style={{ height: "615px", margin: 0 }}>
            <Grid.Column width={1} verticalAlign="middle" textAlign="center">
              {isCarouselTransitionEnd && navigateLeft}
            </Grid.Column>
            <Grid.Column width={14} style={{ padding: "15px 0 14px 0" }}>
              <Grid.Row style={{ marginTop: 25 }}>
                <h3 style={{ marginTop: 8 }}>
                  <img
                    src={listIcon}
                    style={{ marginRight: 6 }}
                    alt="list mode"
                  />{" "}
                  List Display
                </h3>
                <div>Job Seekers can see key job details.</div>
                <div style={{ marginTop: 8, paddingRight: "20%" }}>
                  By purchasing our Sponsored Post your job will always be
                  positioned at the top of the list, for maximum visibility.
                </div>
              </Grid.Row>
              <Grid.Row>
                <img
                  src={
                    "https://firebasestorage.googleapis.com/v0/b/helloradius-caf9d.appspot.com/o/photos%2FGSG-list-display.jpg?alt=media&token=ae5b574b-80ce-4e3b-8b27-78ebd0973721"
                  }
                  alt={"map-list-display"}
                  style={{
                    marginTop: 30,
                    height: "390px",
                    border: "1px solid #c2c5c7",
                    borderRadius: 8,
                  }}
                />
                <div style={{ fontSize: 12 }}>
                  The jobs and map markers shown are for illustrative purposes
                  only and do not represent real jobs.
                </div>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column width={1} verticalAlign="middle" textAlign="center">
              {isCarouselTransitionEnd && navigateRight}
            </Grid.Column>
          </Grid>
        </Carousel.Item>
        <Carousel.Item>
          <Grid style={{ height: "615px", margin: 0 }}>
            <Grid.Column width={1} verticalAlign="middle" textAlign="center">
              {isCarouselTransitionEnd && navigateLeft}
            </Grid.Column>
            <Grid.Column width={14} style={{ padding: "30px 0 14px 0" }}>
              <div className="display-flex">
                <div style={{ width: "58%" }}>
                  <div className="semi-bold">Quick-view display</div>
                  <img
                    src={
                      "https://firebasestorage.googleapis.com/v0/b/helloradius-caf9d.appspot.com/o/photos%2FGSG-QuickViewDisplay2.jpg?alt=media&token=e3a34096-dc16-4230-8f69-8f962e05d294"
                    }
                    alt={"quick-view-mode"}
                    style={{
                      marginTop: 12,
                      height: "319px",
                      // width: "92%",
                      border: "1px solid #c2c5c7",
                      borderRadius: 8,
                    }}
                  />
                </div>
                <div style={{ width: "1%" }} />
                <div style={{ width: "41%" }}>
                  <div className="semi-bold">Full-page display</div>
                  <img
                    src={
                      "https://firebasestorage.googleapis.com/v0/b/helloradius-caf9d.appspot.com/o/photos%2FGSG-FullPageDisplay.jpg?alt=media&token=6c426129-2cdf-41f7-9264-c8255a358d0a"
                    }
                    alt={"full-page-mode"}
                    style={{
                      marginTop: 12,
                      height: "319px",
                      // height: "380px",
                      // width: "87%",
                      border: "1px solid #c2c5c7",
                      borderRadius: 8,
                    }}
                  />
                </div>
              </div>
              <div style={{ margin: "12px 0 15px", width: "75%" }}>
                When a Job Seeker clicks to view your job on our List Display or
                our map page, a Quick-view will show, with the option to view
                your job on a full page.
              </div>
              <div>A Job Seeker will be able to:</div>
              <List style={{ marginTop: 8, paddingLeft: 8 }}>
                <List.Item>
                  <List.Icon name="check" color="grey" />
                  <List.Content>View full job description</List.Content>
                </List.Item>
                <List.Item>
                  <List.Icon name="check" color="grey" />
                  <List.Content>See contact details</List.Content>
                </List.Item>
                <List.Item>
                  <List.Icon name="check" color="grey" />
                  <List.Content>
                    Apply with one click on Hello Radius
                  </List.Content>
                </List.Item>
              </List>
              <div style={{ fontSize: 12, marginTop: 25 }}>
                The jobs and map markers shown are for illustrative purposes
                only and do not represent real jobs.
              </div>
            </Grid.Column>
            <Grid.Column width={1} verticalAlign="middle" textAlign="center">
              {isCarouselTransitionEnd && navigateRight}
            </Grid.Column>
          </Grid>
        </Carousel.Item>
        <Carousel.Item>
          <Grid style={{ height: "615px", margin: 0 }}>
            <Grid.Column width={1} verticalAlign="middle" textAlign="center">
              {isCarouselTransitionEnd && navigateLeft}
            </Grid.Column>
            <Grid.Column width={14} style={{ padding: "24px 25% 14px 0" }}>
              <Grid.Row>
                <h3>
                  <img src={plusIcon} style={{ marginRight: 10 }} alt="plus" />{" "}
                  Post a Job
                </h3>
              </Grid.Row>
              <Grid.Row>
                <div style={{ marginTop: 16 }}>
                  Go to{" "}
                  <span
                    className={"text-link"}
                    onClick={() => {
                      dispatch(closeModal());
                      history.push(EMPLOYER_DASHBOARD_POST_JOB_PATH);
                    }}
                  >
                    Post a Job
                  </span>{" "}
                  then follow 3 quick steps:
                </div>
              </Grid.Row>
              <Grid.Row style={{ marginTop: 30 }}>
                <div className="semi-bold">Step 1: Enter your job details</div>
                <List style={{ marginTop: 10 }}>
                  <List.Item>
                    <List.Icon name="check" color="grey" />
                    <List.Content>
                      Copy & paste your job description
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Icon name="check" color="grey" />
                    <List.Content>
                      Choose your salary type and range
                    </List.Content>
                  </List.Item>
                </List>
              </Grid.Row>
              <Grid.Row style={{ marginTop: 26 }}>
                <div className="semi-bold">Step 2: Contact Information</div>
                <List style={{ marginTop: 10 }}>
                  <List.Item>
                    <List.Icon name="check" color="grey" />
                    <List.Content>
                      Autocomplete your contact details{" "}
                    </List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Icon name="check" color="grey" />
                    <List.Content>Add your job location </List.Content>
                  </List.Item>
                </List>
              </Grid.Row>
              <Grid.Row style={{ marginTop: 26 }}>
                <div className="semi-bold">Step 3: Upload a logo</div>
                <List style={{ marginTop: 10 }}>
                  <List.Item>
                    <List.Icon name="check" color="grey" />
                    <List.Content>Preview your job post</List.Content>
                  </List.Item>
                  <List.Item>
                    <List.Icon name="check" color="grey" />
                    <List.Content>
                      Upload a company logo (optional)
                    </List.Content>
                  </List.Item>
                </List>
              </Grid.Row>
              <Grid.Row style={{ marginTop: 30 }}>
                <div className="semi-bold">Post your job!</div>
                <p style={{ marginTop: 10 }}>
                  Your job post will be sent to our team for review and
                  published within 24 hours. You’ll receive an email
                  notification when it’s published.
                </p>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column width={1} verticalAlign="middle" textAlign="center">
              {isCarouselTransitionEnd && navigateRight}
            </Grid.Column>
          </Grid>
        </Carousel.Item>
        <Carousel.Item>
          <Grid style={{ height: "615px", margin: 0 }}>
            <Grid.Column width={1} verticalAlign="middle" textAlign="center">
              {isCarouselTransitionEnd && navigateLeft}
            </Grid.Column>
            <Grid.Column width={14} style={{ padding: "24px 140px 14px 0" }}>
              <Grid.Row>
                <h3>
                  <img src={menuIcon} style={{ marginRight: 10 }} alt="plus" />{" "}
                  Managing Your Jobs
                </h3>
              </Grid.Row>
              <Grid.Row>
                <div style={{ marginTop: 16, paddingRight: "25%" }}>
                  To view the status of your jobs, go to{" "}
                  <span
                    className={"text-link"}
                    onClick={() => {
                      dispatch(closeModal());
                      history.push(EMPLOYER_DASHBOARD_MANAGE_JOBS_PATH);
                    }}
                  >
                    Manage Jobs
                  </span>
                  .
                </div>
              </Grid.Row>
              <Grid.Row style={{ marginTop: 30 }}>
                <div className="semi-bold">Draft jobs</div>
                <div style={{ marginTop: 8 }}>
                  When you save your progress on our Post a Job form, a draft
                  will be saved. You can make changes by clicking{" "}
                  <img
                    src={editIcon}
                    style={{ width: 23, height: 14, margin: "0 3px" }}
                    alt="list mode"
                  />{" "}
                  <span className={"semi-bold"}>Edit</span>.
                </div>
              </Grid.Row>
              <Grid.Row style={{ marginTop: 40 }}>
                <div className="semi-bold">Jobs under review</div>
                <div style={{ marginTop: 8 }}>
                  Submitted job posts will show here until reviewed by our team
                  and published. <br />
                  To view your job post click{" "}
                  <img
                    src={previewIcon}
                    style={{ width: 23, height: 14, margin: "0 3px" }}
                    alt="list mode"
                  />{" "}
                  <span className={"semi-bold"}>View</span>. The review stage
                  may take up to 24 hours.
                </div>
              </Grid.Row>
              <Grid.Row style={{ marginTop: 40 }}>
                <div className="semi-bold">Active jobs</div>
                <div style={{ marginTop: 8 }}>
                  Published jobs are listed here. Click{" "}
                  <img
                    src={statsIcon}
                    style={{ width: 23, height: 14, margin: "0 3px" }}
                    alt="list mode"
                  />{" "}
                  <span className={"semi-bold"}>Statistics</span> to see your
                  job views. You can edit your job post if needed but doing so,
                  will re-submit it to our team for review. This won’t change
                  the date your job was published.
                </div>
                <div style={{ marginTop: 8 }}>
                  Published jobs can't be deleted, but you can make them
                  inactive (not visible to Job Seekers). To do this, click{" "}
                  <img
                    src={editIcon}
                    style={{ width: 23, height: 14, margin: "0 3px" }}
                    alt="list mode"
                  />{" "}
                  <span className={"semi-bold"}>Edit</span> and click on the
                  toggle{" "}
                  <img
                    src={toggleOn}
                    style={{ height: 13, margin: "0 3px" }}
                    alt="list mode"
                  />
                  . Clicking the toggle again will re-activate the job.
                </div>
                <div style={{ marginTop: 8 }}>
                  To view and manage applications, click{" "}
                  <img
                    src={avatar}
                    style={{ width: 23, height: 14, margin: "0 3px" }}
                    alt="list mode"
                  />{" "}
                  <span className={"semi-bold"}>Applicants</span>. Here you will
                  be able to view candidate profiles and remove applications.
                </div>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column width={1} verticalAlign="middle" textAlign="center">
              {isCarouselTransitionEnd && navigateRight}
            </Grid.Column>
          </Grid>
        </Carousel.Item>
        <Carousel.Item>
          <Grid style={{ height: "615px", margin: 0 }}>
            <Grid.Column width={1} verticalAlign="middle" textAlign="center">
              {isCarouselTransitionEnd && navigateLeft}
            </Grid.Column>
            <Grid.Column width={15} style={{ padding: "30px 15% 14px 0" }}>
              <Grid.Row style={{ marginTop: 10, paddingRight: 50 }}>
                <div className="semi-bold">Expired jobs</div>
                <div style={{ marginTop: 10 }}>
                  Jobs that have expired and marked as "Pending" are being
                  processed by our team. Processed jobs are marked as "Closed"
                  on your account.
                </div>
                <div style={{ marginTop: 10 }}>
                  You’ll receive an email notification when your job has been
                  closed and if you are due a coupon/reward, the details will be
                  included. You can find more information in the{" "}
                  <span
                    className={"text-link"}
                    onClick={() => {
                      dispatch(closeModal());
                      history.push(COUPONS_AND_REWARDS);
                    }}
                  >
                    Coupons & Rewards
                  </span>{" "}
                  section on your account. If you are on a subscription plan you
                  are not eligible for coupons & rewards.
                </div>
                <div style={{ marginTop: 10 }}>
                  Click{" "}
                  <img
                    src={repostIcon}
                    style={{ width: 12, margin: "0 3px" }}
                    alt="list mode"
                  />{" "}
                  <span className={"semi-bold"}>Repost</span>, to repost your
                  job quickly. This will take you to our Post a Job form with
                  all of your job details saved.
                </div>
              </Grid.Row>
              <Grid.Row style={{ marginTop: 65 }}>
                <h3>You’re all set. Post your first job in minutes! </h3>
                <Button
                  className="overwrite-button cta-orange-form"
                  content={"Post a job"}
                  onClick={() => {
                    dispatch(closeModal());
                    history.push(EMPLOYER_DASHBOARD_POST_JOB_PATH);
                  }}
                />
              </Grid.Row>
              <Grid.Row className="display-flex">
                <div
                  className="getting-started-guide-message"
                  style={{ width: "50%", margin: "40px 15px 0 0" }}
                >
                  <h3>Promote your company with us</h3>
                  <div className="body-blue-text" style={{ marginTop: 12 }}>
                    Create a{" "}
                    <span
                      className={"text-link"}
                      onClick={() => {
                        dispatch(closeModal());
                        history.push(EMPLOYER_COMPANY_PROFILE_PATH);
                      }}
                    >
                      company profile
                    </span>{" "}
                    or{" "}
                    <span
                      className={"text-link"}
                      onClick={() => {
                        dispatch(closeModal());
                        history.push(EMPLOYER_PROMOTION_SERVICES_PATH);
                      }}
                    >
                      feature your logo
                    </span>{" "}
                    on our homepage and map page!
                  </div>
                </div>
                <div
                  style={{
                    ...TEAL_BOX,
                    padding: "12px 14px",
                    width: "48%",
                    marginTop: 40,
                  }}
                >
                  <h3>Have a question?</h3>
                  <div onClick={() => dispatch(closeModal())}>
                    Visit our <TextLink text={"FAQs page"} to={FAQ_ROUTE} /> or
                    contact our team at{" "}
                    <span className="semi-bold"> info@helloradius.com</span>
                  </div>
                </div>
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </Carousel.Item>
      </Carousel>
      {isShowProgressBar && (
        <div style={{ padding: "15px 22% 20px", height: 40 }}>
          <HorizontalProgressBar percent={index * 16.6} />
        </div>
      )}
    </ModalWrapper>
  );
}
